import { Button, Card, Empty, Flex, Image, Input, List, Space, Typography } from 'antd';
import { EditOutlined, EyeOutlined, PlusCircleOutlined } from '@ant-design/icons';
import ProductCollectionModal from 'components/product_collection';

const { Search } = Input;

const ProductCollectionMobile = ({ viewModel }) => {
  const {
    data,
    loading,
    openModal,
    selectedId,
    loadData,
    onSearch,
    openCreateModal,
    openEditModal,
    closeModal,
    getViewLink,
    renderCollectionType,
  } = viewModel;

  return (
    <Space direction='vertical' style={{ width: '100%' }}>
      <Card bodyStyle={{ padding: 12 }}>
        <Flex vertical style={{ marginBottom: 12, gap: 12 }}>
          <Search placeholder='Tìm kiếm' onSearch={onSearch} />

          <Button type='primary' block onClick={openCreateModal}>
            <PlusCircleOutlined /> Tạo mới
          </Button>
        </Flex>
      </Card>

      <Card bodyStyle={{ padding: 12 }}>
        <List
          loading={loading}
          dataSource={data}
          locale={{ emptyText: <Empty description='Chưa có collection' /> }}
          renderItem={(record) => {
            const image = record.avatar || record.image;

            return (
              <List.Item style={{ padding: '8px 0' }}>
                <Card style={{ width: '100%' }}>
                  <Flex align='start' gap={12}>
                    {image ? (
                      <Image
                        src={image.url}
                        width={64}
                        height={64}
                        style={{ borderRadius: 8, objectFit: 'cover' }}
                        preview={false}
                      />
                    ) : (
                      <div style={{ width: 64, height: 64, borderRadius: 8, background: '#f5f5f5' }} />
                    )}

                    <Flex vertical style={{ flex: 1, minWidth: 0 }} gap={6}>
                      <Typography.Text strong ellipsis={{ tooltip: record.title }}>
                        {record.title}
                      </Typography.Text>

                      {record.description && (
                        <Typography.Text type='secondary' style={{ fontSize: 12 }} ellipsis={{ tooltip: record.description }}>
                          {record.description}
                        </Typography.Text>
                      )}

                      {renderCollectionType(record.collection_condition)}

                      <Flex gap={8} style={{ marginTop: 4 }}>
                        <Button icon={<EyeOutlined />} onClick={() => window.open(getViewLink(record), '_blank')}>
                          Xem
                        </Button>

                        <Button icon={<EditOutlined />} onClick={() => openEditModal(record.id)}>
                          Sửa
                        </Button>
                      </Flex>
                    </Flex>
                  </Flex>
                </Card>
              </List.Item>
            );
          }}
        />
      </Card>

      <ProductCollectionModal open={openModal} id={selectedId} onClose={closeModal} onChange={loadData} />
    </Space>
  );
};

export default ProductCollectionMobile;
